export interface OrcamentoRequest {
  ID_VENDEDOR?: string;
  ID_CLIENTE?: string;
  STATUSPED?: string;
  SUBSTATUSPED?: number;
  SEQ_PEDIDO?: string;
  ORCAMENTO_FILIAL?: number | string;
  DATAINI?: string;
  ID_FILIAL?: string;
  DATAFIM?: string;
  linhaInicial: number;
  intervalo: number;
  CPFCNPJ?: string;
  pCODUSUR: number;
}

export interface OrcamentoResponse {
  nomE_CLIENTE: string;
  nomE_VENDEDOR: string;
  data: string;
  dataupdate: string;
  datafaturamento?: null;
  seQ_PEDIDO: number;
  iD_PEDIDO: number;
  vltotal: number;
  iD_VENDEDOR: number;
  status: number;
  substatus: number;
  iD_ORCAMENTO_FILIAL: number;
  iD_FILIAL: number;
  observacaO_PC?: string | null;
}

export interface TotalDeVendasRequest {
  pMES: number;
  pANO: number;
}

export const SALES_SUMMARY_POSITION = {
  all: 'all',
  budget: 'O',
  order: 'P',
  integrated: 'L',
  invoiced: 'F',
  returned: 'D',
  cancelled: 'C',
  billingForecast: 'VL',
  rejected: 'R',
} as const;

export interface TotalDeVendasResponse {
  posicao: string;
  valorTotal: number;
  status: string;
}

export interface OrcamentoByIdRequest {
  Matricula: number;
  SeqPedido: string | number;
  CodigoCliente?: number;
  CodigoUsuario?: number;
  CodigoFilial?: number;
  CodigoPlanoPagamento?: number;
  CodigoCobranca?: string;
}

export interface OrcamentoByIdResponse {
  finalizA_ORCA?: number;
  transformA_PEDIDO: string;
  seQ_FORMAENTREGA: number;
  percentualDescontoRodape: number;
  empresa: string;
  cnpj: string;
  ie: string;
  codemitente: string;
  telefonE1: string;
  endereco: string;
  data: string;
  dT_FATURAMENTO: string;
  dT_CANCELADO: string;
  bairro: string;
  qT_DISPONIVEL: number;
  iD_FILIAL: string;
  cidade: string;
  uf: string;
  cep: string;
  telefone: string;
  iD_CLIENTE: number;
  telefonE_VENDEDOR?: null;
  nfE_CHAVE?: null;
  nomE_CLIENTE: string;
  bloqueio: string;
  cpfcnpj: string;
  clientE_IE?: null;
  logradourO_COMERCIAL: string;
  bairrO_COMERCIAL: string;
  cidadE_COMERCIAL: string;
  celular?: null;
  seQ_PEDIDO: number;
  dT_INSERT_BS: string;
  iD_PEDIDO: number;
  nomE_COBRANCA: string;
  taxafv: number;
  coB_CLIENTE: string;
  iD_COBRANCA: string;
  iD_VENDEDOR: number;
  nomE_VENDEDOR: number;
  item?: null;
  codigo: number;
  sku: number;
  codfab?: null;
  nomE_PRODUTO?: null;
  obS_PED: string;
  obS_PED2: string;
  obS_PED3: string;
  obS_PROD?: null;
  nfE_OBS: string;
  ncm?: null;
  un?: null;
  nomE_MARCA?: null;
  qtproduto: number;
  qtreservado: number;
  valorDescontoRodape: number;
  qtfalta: number;
  frete: number;
  totaL_ITEM: number;
  suB_TOTAL: number;
  vlfrete: number;
  vltotal: number;
  enderecoentrega: string;
  numeroentrega: string;
  complementoentrega: string;
  bairroentrega: string;
  cidadeentrega: string;
  ufentrega: string;
  cepentrega: string;
  logradourO_ENTREGA: string;
  complementO_ENTREGA: string;
  bairrO_ENTREGA: string;
  cidadE_ENTREGA: string;
  ceP_ENTREGA: string;
  obsentrega?: string;
  obsentregA2?: string;
  obsentregA3?: string;
  email?: null;
  vlproduto: number;
  adicional: number;
  desconto: number;
  valordesconto: number;
  vlprodutotabela: number;
  siT_SEPARACAO: string;
  status: number;
  observacaO_PC?: string | null;
  statusLog: {
    DateLog: string;
    message: string;
    status: number;
  }[];
  substatus: number;
  pPRECO_GERENCIA: number;
  precO_ATUALIZADO: number;
  n_ORC_GERAL: number;
  n_ORC_FILIAL: number;
  datA_INCLUSAO: string;
  dT_ULT_ATUALIZACAO: string;
  iD_PARCELA: number;
  iD_ENDER_ENTREGA: number;
  iD_REGIAO: number;
  planO_PAGAMENTO: string;
  transporte?: null;
  statusseparacao?: null;
  statuspendenciaorc: number;
  atacarejo: number;
  numseQ_PEDIDO: number;
  fase: number;
  tipovenda: number;
  codprofissional: number;
  unmappedItem?: null;
  items_pedido: ItemsPedidoEntity[];
  limitecredito: number;
  embalagem?: string;
  origenvenda: string;
}
export interface ItemsPedidoEntity {
  obS_PROD?: string;
  embalagem?: string;
  nomeEmbalagem?: string;
  un?: string;
  qT_DISPONIVEL: number;
  vlprodutotabela: number;
  perdescaux: number;
  vlproduto: number;
  retiradaImediata: boolean;
  iD_FILIAL: number;
  valorDescontoAntigo: number;
  codigo: number;
  desconto: number;
  descontoMaximo?: any;
  descontoMaximoResponse: any;
  totaL_ITEM: number;
  item: number;
  nomE_PRODUTO: string;
  nomE_MARCA: string;
  qtproduto: number;
  numseqped: number;
  multiplo: string;
  ambiente?: string;
}

export interface DadosPdfResponse {
  nomeEmpresa: string;
  enderecoEmpresa: string;
  numeroEmpresa: string;
  cnpjEmpresa: string;
  emailEmpresa: string;
  inscricaoEstadualEmpresa: string;
  bairroEmpresa: string;
  cidadeEmpresa: string;
  estadoEmpresa: string;
  cepEmpresa: string;
  telefoneEmpresa: string;
  fax?: string;
  idCliente: number;
  nomeCliente: string;
  documentoCliente: string;
  imCliente?: number;
  enderecoCliente: string;
  numeroCliente: string;
  bairroCliente: string;
  cidadeCliente: string;
  cepCliente: string;
  telefoneCliente: string;
  celularCliente: number;
  idOrcamento: number;
  idCobranca: string;
  dataOrcamento: string;
  dataEmissaoRelatorio: string;
  idVendedor: number;
  desconto: number;
  subTotal: number;
  nomeVendedor: string;
  telefoneVendedor?: string;
  valorTotal: number;
  porcentagemDescontoTotal: number;
  observacaoEntrega?: string;
  observacaoEntrega2?: string;
  observacaoEntrega3?: string;
  observacaoOrcamento?: string;
  observacaoOrcamento2?: string;
  observacaoOrcamento3?: string;
  cepEntrega?: string;
  valorFrete: number;
  idFilial: number;
  tipoRetirada: string;
  planoPagamentoCobranca: string;
  planoPagamento: string;
  observacaoNota?: string;
  tipoVenda: number;
  transformaPedido: string;
  items: DadosPdfItemsResponse[];
}

export interface DadosPdfItemsResponse {
  ambiente: string;
  idProduto: number;
  quantidadeProduto: number;
  numeroSeqPedido: number;
  embalagem: string;
  unidadeMaster: string;
  codigoFabricacao?: string;
  nomeProduto: string;
  descricao: string;
  observacao: string;
  nomeEcommerce: string;
  valorVendaProduto: number;
  valorTabelaProduto: number;
  valorTotal: number;
}

export interface PostOrcamento {
  pcodprofissional?: number;
  piD_CLIENTE?: number;
  piD_VENDEDOR?: number;
  pfilial?: number;
  pcobranca?: number;
  pSTATUSPENDENCIAORC: number | null;
  pparcela?: number;
  ptipovenda?: number;
  pobservacaoent: string | null;
  obS_NOTA?: string;
  origenvenda: string;
  pSTATUS?: number;
  pOBSERVACAO: string;
  pDTENTREGA: null;
  pvlfrete?: number;
  pOBSERVACAO_ITEM: null;
  pTRANSPORTE?: number;
  pseqpedidoentfut: number | null;
  pcpfcgc?: string;
  pENDERECOENTREGA?: string;
  pNUMEROENTREGA?: string;
  pCOMPLEMENTOENTREGA?: string;
  pBAIRROENTREGA?: string;
  pCIDADEENTREGA?: string;
  pUFENTREGA?: string;
  pCEPENTREGA?: string;
  pID_ENDER_ENTREGA: number;
  pAMBIENTE: string;
  pSEQ_FORMAENTREGA?: number;
  produtos?: ProdutosEntity[] | null;
}

export interface ProdutosEntity {
  qtproduto: number;
  iD_FILIAL: number;
  pID_PRODUTO: number;
  qT_DISPONIVEL: number;
  pqtproduto: number;
  pvlproduto: number;
  pvlprodutotabela: number;
  pobservacaO_ITEM: string;
  pvldesc: number;
  pperdesc: number;
  pvlprodutobase: number;
  pAMBIENTE: string;
  embalagem?: string;
}

export interface PutOrcamento {
  seQ_PEDIDO: number;
  iD_FILIAL: number;
  matricula: number;
  tipO_VENDA: number;
  codprofissional: number;
  pVLFRETE: number;
  observacao: string;
  origenvenda: string;
  obS_NOTA: string;
  obsentrega: string;
  transporte: number;
  iD_PARCELA: number;
  iD_CLIENTE: number;
  iD_VENDEDOR: number;
  iD_COBRANCA: string;
  substatus: number;
  status: number;
  endereco: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  uf: string;
  cep: string;
  identrega: number;
  loginenviosep: number;
  loginreenviosep: number;
  pID_ENDER_ENTREGA: number;
  pAMBIENTE: string;
  pSEQ_FORMAENTREGA: number;
  itemsToDelete?: DeletedsEntity[] | null;
  itemsToUpdate?: UpdatedsEntity[] | null;
  itemsToAdd: Addeds;
}
export interface DeletedsEntity {
  seQ_PEDIDO: number;
  iD_PRODUTO: number;
  numseqped: number;
}
export interface UpdatedsEntity {
  seQ_PEDIDO: number;
  qtproduto: number;
  qtfalta: number;
  observacao: string;
  iD_PRODUTO: number;
  numseqped: number;
  preco: number;
  adicional: number;
  precO_TABELA: number;
  desconto: number;
  pAMBIENTE: string;
}
export interface Addeds {
  qtproduto: number;
  iD_FILIAL: number;
  piD_PRODUTO: number;
  pqtproduto: number;
  pvlproduto: number;
  pvlprodutotabela: number;
  pobservacaO_ITEM: string;
  pvldesc: number;
  pperdesc: number;
  pvlprodutobase: number;
  qT_DISPONIVEL: number;
  pAMBIENTE: string;
}

export interface PutStatus {
  seQ_PEDIDO: number;
  status: number;
  substatus: number;
  siT_SEPARACAO: string;
  dataenviosep?: string;
  datareenviosep?: string;
  loginenviosep: number;
  loginreenviosep: number;
}

export const STATUS_ID_MAP_STRING: {
  [key: string]: number;
} = {
  'orçamento-criado': 0,
  'integrado-com-erp': 1,
  'aguardando-integração-com-o-erp': 2,
  'pedido-gerado': 3,
  'integrado-com-erp-pedido': 4,
  'aguardando-integração-com-o-erp-pedido': 5,
  'aguardando-integração-do-winthor': 6,
  pendente: 7,
  bloqueado: 8,
  liberado: 9,
  montado: 10,
  faturado: 11,
  cancelado: 12,
  'aguardando-liberação': 13,
  rejeitado: 14,
  'previsão-de-faturamento': 15,
  devolução: 16,
};

export const STATUS_ID_MAP_NUMBER: {
  [key: number]: string;
} = {
  0: 'ORÇAMENTO CRIADO',
  1: 'INTEGRADO COM ERP',
  2: 'AGUARDANDO INTEGRAÇÃO COM O ERP',
  3: 'PEDIDO GERADO',
  4: 'INTEGRADO COM ERP PEDIDO',
  5: 'AGUARDANDO INTEGRAÇÃO COM O ERP PEDIDO',
  6: 'AGUARDANDO INTEGRAÇÃO DO WINTHOR',
  7: 'PENDENTE',
  8: 'BLOQUEADO',
  9: 'LIBERADO',
  10: 'MONTADO',
  11: 'FATURADO',
  12: 'CANCELADO',
  13: 'AGUARDANDO LIBERAÇÃO',
  14: 'REJEITADO',
  15: 'PREVISÃO DE FATURAMENTO',
  16: 'DEVOLUÇÃO',
};

export interface ResquestBudget {
  produtos: RequestProduct[];
  tipoDescontoRodape: number;
  descontoRodape: number;
  frete: number | null;
}
export interface RequestProduct {
  productId: number;
  quantity: number;
  valorTabela: number;
  descontoUnitario: number;
  tipoDesconto: number;
}
export interface ResponseBudget {
  subtotalItensSemDesconto: number;
  subtotalItensComDesconto: number;
  freteAvulso: number | null;
  totalCarrinho: number;
  valorDescontoRodapeReal: number;
  valorDescontoRodapePorcentagem: number;
  produtos: ResponseProduct[];
}

export interface ResponseProduct {
  idProduto: number;
  quantidade: number;
  desconto: number;
  valorUnidade: number;
  valorUnidadeComDesconto: number;
  valorDescontoReal: number;
  valorDescontoPorcentagem: number;
  subtotal: number;
}

export interface ResponseLibera {
  message: string;
}
